(function () {
  if (window.__oildecoSizeGuideDrawer) return;
  window.__oildecoSizeGuideDrawer = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var drawer = document.querySelector('[data-od-size-guide-drawer]');
    if (!drawer) return;

    var tabs = Array.prototype.slice.call(drawer.querySelectorAll('[data-od-size-guide-tab]'));
    var panels = Array.prototype.slice.call(drawer.querySelectorAll('[data-od-size-guide-panel]'));
    var closeButtons = Array.prototype.slice.call(drawer.querySelectorAll('[data-od-size-guide-close]'));
    var closeButton = drawer.querySelector('.od-size-guide-drawer__close');
    var closeTimer = null;
    var lastFocus = null;

    function getPanel(key) {
      return panels.find(function (panel) {
        return panel.getAttribute('data-guide-key') === key;
      }) || panels[0];
    }

    function loadPanel(panel) {
      if (!panel) return;
      Array.prototype.slice.call(panel.querySelectorAll('img[data-src]')).forEach(function (image) {
        if (!image.getAttribute('src')) {
          image.setAttribute('src', image.getAttribute('data-src'));
        }
      });
    }

    function getDefaultKey() {
      return 'chart';
    }

    function setActive(key) {
      var activePanel = getPanel(key);
      var activeKey = activePanel.getAttribute('data-guide-key');

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-guide-key') === activeKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel === activePanel;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      loadPanel(activePanel);
    }

    function prewarm(key) {
      var panel = getPanel(key || getDefaultKey());
      var image = panel && panel.querySelector('img[data-src], img[src]');
      if (!image || image.dataset.prewarmed) return;

      image.dataset.prewarmed = 'true';
      var preload = new Image();
      preload.src = image.getAttribute('data-src') || image.getAttribute('src');
    }

    function openDrawer(key) {
      lastFocus = document.activeElement;
      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }

      setActive(key || getDefaultKey());
      window.clearTimeout(closeTimer);
      drawer.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('od-size-guide-lock');

      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('od-size-guide-lock');

      closeTimer = window.setTimeout(function () {
        drawer.classList.remove('is-visible');
      }, 390);

      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus({ preventScroll: true });
      }
    }

    function isSizeGuideTrigger(target) {
      if (!target || typeof target.closest !== 'function') return null;

      var explicit = target.closest('[data-od-size-guide-open], .pdp-size-guide-preview');
      if (explicit) return explicit;

      var buttonOrLink = target.closest('a, button');
      if (!buttonOrLink || !buttonOrLink.closest('.section--product-single')) return null;

      var label = (buttonOrLink.textContent || '').replace(/\s+/g, ' ').trim();
      return /size\s*(guide|chart|guidance)/i.test(label) ? buttonOrLink : null;
    }

    function primeTriggers() {
      document.querySelectorAll('.pdp-size-guide-preview').forEach(function (trigger) {
        trigger.removeAttribute('aria-disabled');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('data-od-size-guide-open', '');
      });
    }

    primeTriggers();

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.getAttribute('data-guide-key'));
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = isSizeGuideTrigger(event.target);
      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(trigger.getAttribute('data-size-guide-key'));
    }, true);

    document.addEventListener('pointerover', function (event) {
      if (isSizeGuideTrigger(event.target)) prewarm();
    }, true);

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        prewarm();
      }, { timeout: 2200 });
    } else {
      window.setTimeout(prewarm, 1400);
    }
  });
})();
